import { Component, Prop, Ref } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';

@Component
export class AccountControls extends ThemeComponent {
    @Ref({required: false}) dropdown!: HTMLElement[];
    @Ref() toggleMobileMenu!: HTMLButtonElement;
    @Ref() mobileMenu!: HTMLButtonElement;

    constructor(){
        super();
    }

    /**
     * Initialise.
     */
    init() {
        const active = this.querySelector('[data-active="true"]')?.innerHTML;
        this.toggleMobileMenu.innerHTML = "";
        this.toggleMobileMenu.innerHTML += active;
        this.$listen(this.toggleMobileMenu, 'click', () => this.updateToggleMenu());
    }

    updateToggleMenu() {
        const activeCheck = this.mobileMenu.classList.contains('controls__mobile-cta-wrapper--active');

        if (activeCheck) {
            this.mobileMenu.classList.remove('controls__mobile-cta-wrapper--active');
            this.toggleMobileMenu.classList.remove('controls__main-cta--active');
        }else {
            this.mobileMenu.classList.add('controls__mobile-cta-wrapper--active');
            this.toggleMobileMenu.classList.add('controls__main-cta--active');
        }
    }

}
